import React from 'react'
import { Container, Typography, makeStyles, Link } from '@material-ui/core'

const useStyles = makeStyles(() => ({
    bigContainer: {
        maxWidth: '100%',
        padding: '0px',
    },
    container: {
        maxWidth: '100%',
        backgroundColor: '#e9e9e9',
        paddingBottom: '3%',
        paddingTop: '3%',
        paddingRight: '3%',
        paddingLeft: '3%',
    },
    container2: {
        maxWidth: '100%',
        paddingBottom: '3%',
        paddingTop: '3%',
        paddingRight: '3%',
        paddingLeft: '3%',
    },
    title: {
        fontFamily: 'Helvetica, sans-serif',
        color: '#273746',
    },
    description: {
        fontFamily: 'Helvetica, sans-serif',
        color: '#273746',
    }
}))

export default function SecaoSobre() {
    const {bigContainer, container, container2, title, description} = useStyles()

    return (
        <Container className={bigContainer}>
            <Container className={container}>
                <Typography gutterBottom variant='h5' component='div' className={title}>
                Sobre nós
                </Typography>
                <Typography variant='body2' color='text.secondary' className={description}>
                Situada na cidade de Amparo S/P, conta com equipamentos de usinagem para diversos fins, tornos mecânicos, tornos CNC, tornos automáticos, fresadoras convencionais, fresadoras CNC, centros de usinagem CNC, entre outros. 
                <Link href='/#/sobre'> Saiba mais</Link>
                </Typography>
            </Container>
            <Container className={container2}>
                <Typography gutterBottom variant='h5' component='div' className={title}>
                Atendendo sua necessidade
                </Typography>
                <Typography variant='body2' color='text.secondary' className={description}>
                Nossos produtos são elaborados de acordo com as normas e exigências dos nossos clientes, inclusive quanto ao fornecimento do material. Nossos fornecedores atendem a todas as especificações necessárias dos materiais ou componentes especificados em nosso pedido de compras. 
                <Link href='/#/servicos'> Saiba mais sobre nossos serviços</Link>
                </Typography>
            </Container>
            <Container className={container}>
                <Typography gutterBottom variant='h5' component='div' className={title}>
                Entre em contato conosco
                </Typography>
                <Typography variant='body2' color='text.secondary' className={description}>
                Nossa equipe esta pronta para atendê-lo, com qualidade, eficiência e rapidez. 
                <Link href='/#/contato'> Entre em contato</Link>
                </Typography>
            </Container>
        </Container>
    )
}